export default __webpack_public_path__ + "static/media/bri.f53dfd2f.png";